import { createFileRoute } from "@tanstack/react-router";
import ThankYouExistingPatientEs from "@/pages/es/ThankYouExistingPatientEs";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/thank-you-existing-patient`;

export const Route = createFileRoute("/es/thank-you-existing-patient")({
  head: () => ({
    meta: [
      { name: "robots", content: "noindex, follow" },
      {
        title:
          "Gracias — Solicitud de verificación de beneficios | Neuro Wellness",
      },
      {
        name: "description",
        content:
          "Gracias por solicitar una verificación de beneficios. Un coordinador de cuidado le contactará dentro de un día hábil para verificar su cobertura y programar.",
      },
      {
        property: "og:title",
        content:
          "Gracias — Solicitud de verificación de beneficios | Neuro Wellness",
      },
      {
        property: "og:description",
        content:
          "Gracias por solicitar una verificación de beneficios. Un coordinador de cuidado le contactará dentro de un día hábil para verificar su cobertura y programar.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/thank-you-existing-patient"),
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <ThankYouExistingPatientEs />;
}
